import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserInfoStore } from './user-info.state';
import { UserPrivilege } from '../../../features/main-page/types';
import { OrganizationInfo } from 'shared/models/Organization';

const selectUserInfoFeatureState =
  createFeatureSelector<UserInfoStore>('userInfo');

export const selectSelectedOrganization = createSelector(
  selectUserInfoFeatureState,
  (state: UserInfoStore) => state.selectedUserRole?.organization,
);

export const selectSelectedOrganizationId = createSelector(
  selectUserInfoFeatureState,
  (state: UserInfoStore) => state.selectedUserRole?.organization?.id,
);

export const selectSelectedRoleId = createSelector(
  selectUserInfoFeatureState,
  (state: UserInfoStore) => state.selectedUserRole?.role?.id,
);

export const selectUserOrganizations = createSelector(
  selectUserInfoFeatureState,
  (state: UserInfoStore) => {
    const orgMap = new Map<string, OrganizationInfo>();

    for (const role of state.userRoles ?? []) {
      const org = role.organization;
      orgMap.set(org.id, org);
    }

    return [...orgMap.values()];
  },
);

export const selectUserRoles = createSelector(
  selectUserInfoFeatureState,
  (state: UserInfoStore) => state.userRoles,
);

export const selectUserLanguage = createSelector(
  selectUserInfoFeatureState,
  (state: UserInfoStore) => state.userLanguage,
);

export const selectUserPermissions = createSelector(
  selectUserInfoFeatureState,
  (state: UserInfoStore) => state.userPermissions,
);

export const selectIsUserDataLoaded = createSelector(
  selectUserRoles,
  selectUserPermissions,
  selectSelectedOrganization,
  (userRoles, userPermissions, selectedOrganization) =>
    userRoles.length > 0 &&
    selectedOrganization !== undefined &&
    userPermissions !== undefined,
);

export const selectUserHasPermission = (
  privilege: UserPrivilege | UserPrivilege[],
) =>
  createSelector(
    selectUserPermissions,
    (permissions) =>
      !!permissions.find((userRole) => {
        if (Array.isArray(privilege)) {
          return privilege.includes(userRole.privilege);
        }
        return userRole.privilege === privilege;
      }),
  );
